import { HubPhysicsConfig } from '../types/hub.types';

export const HUB_PHYSICS: HubPhysicsConfig = {
  maxSpeed: 1,
  accel: 0.1,
  decel: 0.1,
  playerCollision: { halfWidth: 4, halfHeight: 3 },
  interactionRange: 15,
};

/**
 * Hub player sprite. Reuses the dungeon `lumephons-*` spritesheets via
 * EntityDisplay.
 *
 * `runThreshold`: minimum speed above which the run animation kicks in
 * (idle otherwise). Avoids idle ↔ run flicker during deceleration.
 */
export const HUB_PLAYER_SPRITES = {
  idle: 'lumephons-idle',
  run: 'lumephons-run',
  getUp: 'lumephons-getUp',
  width: 20,
  height: 20,
  anchor: [0.5, 0.8],
  runThreshold: 0.05,
};
